<template>
  <div class="animated fadeIn">
    <b-row style="width: 100%;">
      <b-col v-for="(card, index) in cards" :key="`dashboard-card-${index}`">
        <simple-card :card="card" :data="get(data, card.key, [])"></simple-card>
      </b-col>
    </b-row>

    <b-row style="width: 100%;">
      <component v-for="(item, index) in widgets"
        :key="'dashboard-widget-' + index"
        :is="item">
      </component>
    </b-row>
  </div>
</template>

<script>
import { get } from 'lodash'
import Widgets from '@/components/widgets'
import { resolveHTTP } from '@/services/api'

export default {
  data () {
    return {
      data: {},

      cards: [
        {
          title: 'Usuários',
          key: 'users',
          showTotal: false,
          action: null
        },
        {
          title: 'Total de Documentos',
          key: 'documents',
          showTotal: true,
          action: null
        },
        {
          title: 'Últimas Noticias',
          key: 'stories',
          showTotal: true,
          action: null
        }
      ],

      // More specifc widgets
      widgets: [
        Widgets.Bl.Authorizations,
        Widgets.Bl.ProcessFiles,
        Widgets.System.User,
        Widgets.Bl.Contacts
        // Widgets.Bl.CareerContacts
      ]
    }
  },

  methods: {
    get,

    refresh () {
      let self = this

      resolveHTTP('/dashboard/cards').index()
        .then(function (res) { self.data = res.data })
    }
  },

  created () {
    this.refresh()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/Dashboard.vue